export default __webpack_public_path__ + "static/media/calendar.888f7cf4.svg";